import { UseComboboxGetItemPropsOptions } from "downshift";
import { AutoCompleteItem } from "./interface";
import {
  TicketHeading,
  TicketRoot,
  TicketSub,
  TicketSubItem,
} from "../ticket/Ticket";

export default function AutoCompleteListItem<T>(props: {
  item: AutoCompleteItem<T>;
  index: number;
  highlightedIndex: number;
  getItemProps: (
    options: UseComboboxGetItemPropsOptions<AutoCompleteItem<T>>,
  ) => any;
  focusOnMount?: boolean;
}) {
  const { getItemProps, item, highlightedIndex, index, focusOnMount } = props;
  if (!item.subheader) {
    return (
      <div
        {...getItemProps({ item, index } as any)}
        key={`${item.id}${index}`}
        role="button"
        className={`c-dropdown-search-item${
          highlightedIndex === index ? " test-highlight" : ""
        }`}
      >
        {item.header}
      </div>
    );
  }

  return (
    <div {...getItemProps({ item, index } as any)}>
      <TicketRoot
        button
        icon="arrow"
        iconLeft={item.icon}
        className={`${highlightedIndex === index ? " test-highlight" : ""}`}
        key={`${item.id}${index}`}
        focusOnMount={focusOnMount}
      >
        <TicketHeading>
          <h4 className="h5">{item.header}</h4>
        </TicketHeading>
        {item.subheader && (
          <TicketSub>
            <TicketSubItem>{item.subheader}</TicketSubItem>
          </TicketSub>
        )}
      </TicketRoot>
    </div>
  );
}

export function AutoCompleteFormSelectedItem<T>(props: {
  item: AutoCompleteItem<T>;
  onClick: (e) => void;
  title: string;
  focusOnMount?: boolean;
}) {
  const { item, onClick, title, focusOnMount } = props;

  return (
    <div className="border rounded w-100" title={title}>
      <TicketRoot
        button
        icon="close"
        iconLeft={item.icon}
        onClick={onClick}
        focusOnMount={focusOnMount}
      >
        <TicketHeading>
          <h4 className="h5">{item.header}</h4>
        </TicketHeading>
        <TicketSub>
          <TicketSubItem>{item.subheader}</TicketSubItem>
        </TicketSub>
      </TicketRoot>
    </div>
  );
}
